import * as React from "react"
import * as ReactDom from "react-dom"
import Legals from "../components/views/legals";
import { requestPageData } from "../services/api";
import { checkLang } from "../services/general";

export const page = async () => {
    const LegalsContainer = document.getElementById('legals')
    const LEGALSGINFO = window.drupalSettings.react.node || await requestPageData({ content: "partner", nid: LegalsContainer.dataset.nid, langcode: checkLang() })
    ReactDom.render(<Legals  data={LEGALSGINFO} />, LegalsContainer)
}